<script>
import TrekLoading from '@/components/TrekLoading';

export default {
  name: 'OrderDetails',

  components: {
    TrekLoading,
  },

  props: {
    checkoutStep: {
      type: String,
      default: '',
    },
    partTypeKey: {
      type: String,
      default: '',
    },
    bikesOrderDetails: {
      type: Object,
      default: () => {},
    },
    partsOrderDetails: {
      type: Object,
      default: () => {},
    },
    customWaterBottlesOrderDetails: {
      type: Object,
      default: () => {},
    },
    projectOneBikesOrderDetails: {
      type: Object,
      default: () => {},
    },
    bikesOrderCode: {
      type: String,
      default: '',
    },
    bikesOrderUpdate: {
      type: String,
      default: '',
    },
    partsOrderCode: {
      type: String,
      default: '',
    },
    partsOrderUpdate: {
      type: String,
      default: '',
    },
    customWaterBottlesOrderCode: {
      type: String,
      default: '',
    },
    customWaterBottlesOrderUpdate: {
      type: String,
      default: '',
    },
    projectOneBikesOrderCode: {
      type: String,
      default: '',
    },
    projectOneBikesOrderUpdate: {
      type: String,
      default: '',
    },
    projectOneWarrantyFramesetOrderCode: {
      type: String,
      default: '',
    },
    projectOneWarrantyFramesetOrderUpdate: {
      type: String,
      default: '',
    },
    timeoutError: {
      type: Boolean,
      default: false,
    },
    emptyReturnError: {
      type: Boolean,
      default: false,
    },
    isDropShip: {
      type: Boolean,
      default: false,
    },
    allocatedItemsExistenceMap: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      loading: true,
    };
  },
  computed: {
    orderDetails() {
      let selectedTabOrderDetails;
      switch (this.partTypeKey) {
        case 'bikes':
          selectedTabOrderDetails = this.bikesOrderDetails;
          break;
        case 'parts':
          selectedTabOrderDetails = this.partsOrderDetails;
          break;
        case 'customWaterBottles':
          selectedTabOrderDetails = this.customWaterBottlesOrderDetails;
          break;
        case 'projectOneBikes':
          selectedTabOrderDetails = this.projectOneBikesOrderDetails;
          break;
        default:
          break;
      }
      return selectedTabOrderDetails;
    },
  },
};
</script>
